import styles from './Footer.module.scss'

function Footer() {
  return (
    <footer className={styles.footer}>
      {/* <p>made with love by zn</p> */}
    </footer>
  )
}

export default Footer
